import { Input, Output, EventEmitter, ViewChild, Directive } from '@angular/core';
import { Observable } from 'rxjs';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { ZefFormComponent } from './modules/form/form.component';
import { ZefForm } from './form.service';
import { Actions, ofType } from '@ngrx/effects';
import { AbstractControlState, SetValueAction } from 'ngrx-forms';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export class ZefFormBase<S> {
  @Input()
  state: S;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() submit = new EventEmitter<void | S>();

  @ViewChild(ZefFormComponent, { static: false })
  formRef: ZefFormComponent<S>;

  triggerSubmit() {
    if (this.formRef) {
      this.formRef.triggerSubmit();
    } else {
      console.warn('Could not find formRef');
    }
  }
}

export const formValueOnValid = <T>(form: ZefForm<T>) => (source: Observable<any>) => source.pipe(
  withLatestFrom(form.value$, form.valid$),
  filter(([ _, __, v ]) => !!v),
  map(([ _, d ]) => d)
);

export function ofFormFieldChanged<T extends { [key: string]: any }>(form: ZefForm<T>, ...controlNames: (keyof T)[]) {
  return (source: Actions) => source.pipe(
    ofType<SetValueAction<unknown>>(SetValueAction.TYPE),
    withLatestFrom(form.state$),
    filter(([action, state]) => {
      const controlsExists = controlNames.every((controlName) => state.controls[controlName]);
      if (!controlsExists) return false;

      const directControlChange = controlNames
        .map((controlName) =>
          (state.controls[controlName] as AbstractControlState<unknown>).id
        )
        .includes(action.controlId);

      if (directControlChange) return true;

      return action.controlId === state.id
        && typeof action.value === 'object'
        && action.value !== null
        && controlNames.some((controlName) => Object.hasOwn(action.value as object, controlName));
    }),
    map(([action, state]) => ({ action, state }))
  )
}
